<template>
  <div id="contactusCard">
    <div class="contactcardContainer">
      <div class="cardTitle">
        {{ cards.title }}
      </div>
      <div class="details">
        <div class="part1">
          <div class="iconWithTitle d-flex">
            <div class="Icon">
              <img src="../../assets/icons/phoneIcon.svg" class="innerIcon phoneIcon">
            </div>
            <div class="Title">
              {{ $t('contactUs.phone') }}
            </div>
          </div>
          <div class="Number">
            {{ cards.phoneNumber }}
          </div>
        </div>
        <!-- <div class="part2">
        <div class="iconWithTitle d-flex">
          <div class="Icon">
            <img src="../../assets/icons/faxIcon.svg" class="innerIcon faxIcon" >
          </div>
          <div class="Title">
            {{$t('contactUs.fax')}}
          </div>
        </div>
        <div class="Number">
          {{cards.fax}}
        </div>
      </div> -->
        <div class="part3">
          <div class="iconWithTitle d-flex">
            <div class="Icon">
              <img src="../../assets/icons/emailIcon.svg" class="innerIcon faxIcon">
            </div>
            <div class="Title">
              {{ $t('contactUs.email') }}
            </div>
          </div>
          <div class="Number">
            {{ cards.email }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'ContactusCard',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      cards: {},
      lang: this.$lang
    }
  },
  created () {
    this.cards = this.data
  },
  mounted () {
    this.arabic()
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        $('.cardTitle').css('font-family', 'Mtn-arabic-bold')
        $('.Title').css('font-family', 'Mtn-arabic-regular')
        $('.firstTitle, .secondTitle').css('font-family', 'Mtn-arabic-regular')
        $('.Number').css('direction', 'ltr')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";

.contactcardContainer {
  height: 330px;
  width: 250px;
  background-image: $--gray-gradient2;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 30px;
  margin: 0 2vw;
  /*<!--box-shadow: 35px 35px 40px -16px rgba(0, 0, 0, 0.099);-->*/
  box-shadow: -8px 35px 53px -18px rgba(0, 0, 0, 0.099);
}

@media (max-width: 1250px) {
  .contactcardContainer {
    margin: 0 1vw;

  }
}

.cardTitle {
  font-family: Mtn-bold;
  color: $--yellow;
  font-size: 17px;
  padding: 35px 10px 3px 10px;
}

.iconWithTitle {
  justify-content: center;
  align-items: center;
  width: 85%;
  padding: 5px 0;
}

.innerIcon {
  padding: 0 10px
}

.part1,
.part2,
.part3 {
  padding: 10px 10px;
}

.Title {
  font-weight: 700;
  font-size: 14px;
  color: $--yellow;
}

.phoneIcon {
  width: 50px;
}

.faxIcon {
  width: 40px;
}

/*
  */</style>
